import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuBuhumuza'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));


const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

// Données de MUYINGA
const muyingaData = {
  title: "RÉPARTITION DE LA POPULATION DE LA COMMUNE DE MUYINGA PAR ZONE ET COLLINE",
  province: {
    id: "1",
    name: "MUYINGA",
    commune: {
      id: "106",
      name: "MUYINGA",
      total: 492100,
      zones: [
        {
          id: "10601",
          name: "PARK NATIONAL D",
          total: 0,
          collines: [
            { id: "10601101", name: "PARK NATIONAL DE LA RUVUBU", population: 0 },
            { id: "10601102", name: "PARK NATIONAL DE LA RUVUBU", population: 0 }
          ]
        },
        {
          id: "10602",
          name: "BWASARE",
          total: 33254,
          collines: [
            { id: "10602101", name: "BUTIRABURA", population: 3320 },
            { id: "10602102", name: "RUKINZO", population: 4462 },
            { id: "10602103", name: "KAGUHU", population: 6166 },
            { id: "10602104", name: "KARAMA", population: 4027 },
            { id: "10602105", name: "JANI", population: 3409 },
            { id: "10602106", name: "KAGUGWE", population: 3389 },
            { id: "10602107", name: "BWASARE", population: 4060 },
            { id: "10602108", name: "GISHUHA", population: 4421 }
          ]
        },
        {
          id: "10603",
          name: "BUHINYUZA",
          total: 23530,
          collines: [
            { id: "10603101", name: "KIBIMBA", population: 4695 },
            { id: "10603102", name: "NYARUNAZI", population: 5636 },
            { id: "10603103", name: "KAREHE", population: 3294 },
            { id: "10603104", name: "NYARUHENGERI", population: 2893 },
            { id: "10603105", name: "NYABUCUGU", population: 1667 },
            { id: "10603106", name: "RUGAZI", population: 2012 },
            { id: "10603107", name: "MABAGO", population: 1998 },
            { id: "10603108", name: "BUHINYUZA", population: 1335 }
          ]
        },
        {
          id: "10604",
          name: "CUMBA",
          total: 20915,
          collines: [
            { id: "10604101", name: "CUMBA", population: 3182 },
            { id: "10604102", name: "KIRINGANIRE", population: 2448 },
            { id: "10604103", name: "NYAMIRAMBO", population: 2745 },
            { id: "10604104", name: "BUTIHINDA", population: 1732 },
            { id: "10604105", name: "BWICA", population: 3086 },
            { id: "10604106", name: "MIZUGA", population: 2209 },
            { id: "10604107", name: "RUGANIRWA", population: 2322 },
            { id: "10604108", name: "NYARUSANGE", population: 1625 },
            { id: "10604109", name: "BURENZA", population: 1566 }
          ]
        },
        {
          id: "10605",
          name: "GASAVE",
          total: 43973,
          collines: [
            { id: "10605101", name: "MURAMBA", population: 6752 },
            { id: "10605102", name: "GITARAMUKA", population: 5618 },
            { id: "10605103", name: "BUNYWANA", population: 5770 },
            { id: "10605104", name: "NTOBWE", population: 4550 },
            { id: "10605105", name: "KARONGWE", population: 5136 },
            { id: "10605106", name: "BUGUNGU", population: 3240 },
            { id: "10605107", name: "GASAVE", population: 4482 },
            { id: "10605108", name: "KIYANGE", population: 5310 },
            { id: "10605109", name: "BUTIHINDA", population: 3115 }
          ]
        },
        {
          id: "10606",
          name: "GASORWE",
          total: 30867,
          collines: [
            { id: "10606101", name: "MASASU", population: 3392 },
            { id: "10606102", name: "KARIRA", population: 3102 },
            { id: "10606103", name: "GIKWIYE", population: 2884 },
            { id: "10606104", name: "KINAMA", population: 8142 },
            { id: "10606105", name: "BIHOGO", population: 5974 },
            { id: "10606106", name: "RUSIMBUKO", population: 1981 },
            { id: "10606107", name: "KIRYAMA", population: 2404 },
            { id: "10606108", name: "KARAMBO", population: 2988 }
          ]
        },
        {
          id: "10607",
          name: "HIGIRO",
          total: 22264,
          collines: [
            { id: "10607101", name: "HIGIRO", population: 4400 },
            { id: "10607102", name: "NYUNGU", population: 4740 },
            { id: "10607103", name: "KIGOGANYA", population: 3292 },
            { id: "10607104", name: "NGOGOMO", population: 3732 },
            { id: "10607105", name: "NYARUBAMBWE", population: 3343 },
            { id: "10607106", name: "KARIMBI", population: 2757 }
          ]
        },
        {
          id: "10608",
          name: "JARAMA",
          total: 22898,
          collines: [
            { id: "10608101", name: "BURASIRA", population: 3555 },
            { id: "10608102", name: "KARA", population: 4174 },
            { id: "10608103", name: "JARAMA", population: 4112 },
            { id: "10608104", name: "RUVUMU", population: 2187 },
            { id: "10608105", name: "NYAGISHIRU", population: 2428 },
            { id: "10608106", name: "NYANKURAZO", population: 2100 },
            { id: "10608107", name: "RUGONGO", population: 2992 },
            { id: "10608108", name: "GIHONGO", population: 1350 }
          ]
        },
        {
          id: "10609",
          name: "KIYANZA",
          total: 19160,
          collines: [
            { id: "10609101", name: "MUKUNGU", population: 2837 },
            { id: "10609102", name: "GASENYI", population: 2044 },
            { id: "10609103", name: "RURTYAZO", population: 2260 },
            { id: "10609104", name: "KIGAJO", population: 1862 },
            { id: "10609105", name: "BONERO", population: 1954 },
            { id: "10609106", name: "GAHEKENYA", population: 1512 },
            { id: "10609107", name: "GITABA", population: 1234 },
            { id: "10609108", name: "CIYANDO", population: 842 },
            { id: "10609109", name: "MUSENGA", population: 958 },
            { id: "10609110", name: "KIYANZA", population: 1196 },
            { id: "10609111", name: "BUBAJI", population: 1272 },
            { id: "10609112", name: "KIBONGERA", population: 1189 }
          ]
        },
        {
          id: "10610",
          name: "KAYENZI",
          total: 25490,
          collines: [
            { id: "10610101", name: "KAYENZI", population: 5624 },
            { id: "10610102", name: "NKOYOYO", population: 5163 },
            { id: "10610103", name: "RUSENGO", population: 4228 },
            { id: "10610104", name: "KIBONGERA", population: 3408 },
            { id: "10610105", name: "MUSENGA", population: 4462 },
            { id: "10610106", name: "MAGENI", population: 2605 }
          ]
        },
        {
          id: "10611",
          name: "KIREMBA",
          total: 26630,
          collines: [
            { id: "10611101", name: "GASURU", population: 5205 },
            { id: "10611102", name: "KIREMBA", population: 6594 },
            { id: "10611103", name: "MARTYAZO", population: 3488 },
            { id: "10611104", name: "KIZI", population: 6127 },
            { id: "10611105", name: "KIVUBO", population: 3781 },
            { id: "10611106", name: "KIMANGA", population: 1435 }
          ]
        },
        {
          id: "10612",
          name: "MUNAGANO",
          total: 22251,
          collines: [
            { id: "10612101", name: "MUSENYI", population: 4721 },
            { id: "10612102", name: "GATOVU", population: 4355 },
            { id: "10612103", name: "SANZWE", population: 3901 },
            { id: "10612104", name: "NYAMARUMBA", population: 4496 },
            { id: "10612105", name: "NTAMBA", population: 2589 },
            { id: "10612106", name: "MUNAGANO", population: 1512 },
            { id: "10612107", name: "BUHURANA", population: 677 }
          ]
        },
        {
          id: "10613",
          name: "MURAMA",
          total: 36424,
          collines: [
            { id: "10613101", name: "MURAMA", population: 11834 },
            { id: "10613102", name: "MWURIRE", population: 6317 },
            { id: "10613103", name: "GASASA", population: 6423 },
            { id: "10613104", name: "MUBUGA", population: 3273 },
            { id: "10613105", name: "RYABIHIRA", population: 3731 },
            { id: "10613106", name: "RUSUMO", population: 2248 },
            { id: "10613107", name: "KAVUMU", population: 2598 }
          ]
        },
        {
          id: "10614",
          name: "MWAKIRO",
          total: 21009,
          collines: [
            { id: "10614101", name: "MWAKIRO", population: 3183 },
            { id: "10614102", name: "GIHOZA", population: 3337 },
            { id: "10614103", name: "BUTOBWE", population: 3296 },
            { id: "10614104", name: "GAKOMBE", population: 1983 },
            { id: "10614105", name: "MUYANGE", population: 1784 },
            { id: "10614106", name: "KAREHE", population: 1914 },
            { id: "10614107", name: "KABINGO", population: 1728 },
            { id: "10614108", name: "KIBWIRWA", population: 1518 },
            { id: "10614109", name: "KIBANDE", population: 1322 },
            { id: "10614110", name: "BUGONZA", population: 944 }
          ]
        },
        {
          id: "10615",
          name: "MUYINGA",
          total: 94204,
          collines: [
            { id: "10615101", name: "QUARTIER KINYOTA", population: 23173 },
            { id: "10615102", name: "QUARTIER MUYINGA", population: 11938 },
            { id: "10615103", name: "QUARTIER KIBOGOYE", population: 9702 },
            { id: "10615104", name: "QUARTIER MUKONI", population: 10556 },
            { id: "10615105", name: "QUARTIER KWIBUYE", population: 5563 },
            { id: "10615106", name: "CIBARI", population: 7755 },
            { id: "10615107", name: "KAREMERA", population: 3848 },
            { id: "10615108", name: "GITONGWE", population: 3154 },
            { id: "10615109", name: "KIVOGA", population: 4529 },
            { id: "10615110", name: "KIRYAMA", population: 3071 },
            { id: "10615111", name: "GAHORORO", population: 2760 },
            { id: "10615112", name: "BUGOMORA", population: 2309 },
            { id: "10615113", name: "BURIMA", population: 2791 },
            { id: "10615114", name: "RWIMBOGO", population: 3055 }
          ]
        },
        {
          id: "10616",
          name: "RUGABANO",
          total: 22536,
          collines: [
            { id: "10616101", name: "RUGABANO", population: 3549 },
            { id: "10616102", name: "RUKANYA", population: 3372 },
            { id: "10616103", name: "KADENDE", population: 1731 },
            { id: "10616104", name: "RUSHERI", population: 2611 },
            { id: "10616105", name: "KAVUGANGOMA", population: 2057 },
            { id: "10616106", name: "BUKWANZI", population: 1769 },
            { id: "10616107", name: "GISUMA", population: 2677 },
            { id: "10616108", name: "GAHEMBA", population: 2936 },
            { id: "10616109", name: "MUKUNGUZA", population: 1834 }
          ]
        },
        {
          id: "10617",
          name: "RUGARI",
          total: 26695,
          collines: [
            { id: "10617101", name: "RUGARI", population: 4440 },
            { id: "10617102", name: "BUNYWANA", population: 3094 },
            { id: "10617103", name: "MAHONDA", population: 2314 },
            { id: "10617104", name: "RUYIVYI", population: 2725 },
            { id: "10617105", name: "RUTOKE", population: 3408 },
            { id: "10617106", name: "KINAZI", population: 5282 },
            { id: "10617107", name: "GATONGATI", population: 3546 },
            { id: "10617108", name: "MIGONGO", population: 1886 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageBuhumuzaMuyinga = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(muyingaData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = muyingaData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info MUYINGA
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {muyingaData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de MUYINGA`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de MUYINGA
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE MUYINGA</TableCell>
                          <TableCell align="right">{muyingaData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de Muyinga
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de Muyinga est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de Muyinga ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageBuhumuzaMuyinga;